import { seatIndexParser } from './utils/pokerInboundUtils';
export const SHOW_BLANK_CHAT_BUBBLE_PAYLOAD_DEFINITION = {
    definitionParts: [{ name: 'seatIndex', parser: seatIndexParser }]
};
